export const isSdskuDisplayable = (superDuperSku) => {
  const { attributes = [] } = superDuperSku;
  return !!(attributes?.length !== 0
    && attributes[0]?.attributeName
    && attributes[0].attributeValues?.length > 1);
};
